"use strict";

const $ = require("jquery");

class DropdownNavigation {
    constructor() {
        $(".ce-dropdown-navigation select").on("change", function () {
            const url = $(this).children("option:selected").val();
            if (url !== "") document.location.href = url;
        });
    }
}

module.exports = DropdownNavigation;
